import { createBrowserRouter } from 'react-router';
import { DevLoginPage, LoginPage, RequireSession } from './routes/auth';
import { AdminPage } from './routes/admin';
import { AccountPage } from './routes/account';
import { BetaPage } from './routes/beta';
import { ReportPage } from './routes/report';
import { PricingPage } from './routes/pricing';
import { BrandPage } from './routes/brandPage';
import { SavingsPage } from './routes/savingsPage';
import { GuidePage } from './routes/guide';
import { MembersPage } from './routes/members';
import {
  ExtensionPage,
  InvitePage,
  NotFoundPage,
  PrivacyPage,
  RouteError,
  TermsPage,
  RefundsPage,
  PublicGuidePage,
} from './routes/misc';
import { HomePage, LandingPage } from './routes/landing';
import { HomeDashboard, MyGuidesPage } from './routes/home';
import {
  GeneralSettingsPage,
  PlanSettingsPage,
  ExportSettingsPage,
  RecordingSettingsPage,
  SettingsPage,
  SubscribePage,
} from './routes/settings';
import { StatsPage } from './routes/stats';
import { MacAppPage, MacLinkPage } from './routes/mac';
import { NewTeamPage, WorkspacePage } from './routes/workspace';

export const router = createBrowserRouter([
  // Um erro ao mostrar uma página: regista-o e mostra «Não foi possível carregar».
  {
    errorElement: <RouteError />,
    children: [
      { path: '/entrar', element: <LoginPage /> },
      // Login de desenvolvimento: a rota nem existe no build de produção.
      ...(import.meta.env.DEV ? [{ path: '/dev/entrar', element: <DevLoginPage /> }] : []),
      { path: '/s/:token', element: <PublicGuidePage /> },
      // Embed: o mesmo guia público, compacto, para incorporar noutras páginas.
      { path: '/e/:token', element: <PublicGuidePage embed /> },
      // Páginas públicas: o endereço em inglês e o em português (os links seguem a língua).
      { path: '/privacy', element: <PrivacyPage /> },
      { path: '/privacidade', element: <PrivacyPage /> },
      { path: '/terms', element: <TermsPage /> },
      { path: '/beta', element: <BetaPage /> },
      { path: '/teste', element: <BetaPage /> },
      { path: '/testes', element: <BetaPage /> },
      // Anomalias de quem testa (ligação pessoal no email de boas-vindas)
      { path: '/reportar', element: <ReportPage /> },
      { path: '/reportar/:token', element: <ReportPage /> },
      { path: '/termos', element: <TermsPage /> },
      { path: '/refunds', element: <RefundsPage /> },
      { path: '/reembolsos', element: <RefundsPage /> },
      { path: '/pricing', element: <PricingPage /> },
      { path: '/precos', element: <PricingPage /> },
      // Página do produto: em «/» para quem não tem sessão (quem tem vai para «/inicio»); em «/produto» para todos.
      { path: '/', element: <HomePage /> },
      { path: '/product', element: <LandingPage /> },
      { path: '/produto', element: <LandingPage /> },
      {
        element: <RequireSession />,
        children: [
          { path: '/inicio', element: <HomeDashboard /> },
          { path: '/guias', element: <MyGuidesPage /> },
          { path: '/w/:workspaceId', element: <WorkspacePage /> },
          { path: '/w/:workspaceId/membros', element: <MembersPage /> },
          { path: '/w/:workspaceId/marca', element: <BrandPage /> },
          { path: '/w/:workspaceId/poupanca', element: <SavingsPage /> },
          { path: '/w/:workspaceId/estatisticas', element: <StatsPage /> },
          { path: '/w/:workspaceId/definicoes', element: <SettingsPage /> },
          { path: '/w/:workspaceId/definicoes/geral', element: <GeneralSettingsPage /> },
          { path: '/w/:workspaceId/definicoes/gravacoes', element: <RecordingSettingsPage /> },
          { path: '/w/:workspaceId/definicoes/plano', element: <PlanSettingsPage /> },
          { path: '/w/:workspaceId/definicoes/exportar', element: <ExportSettingsPage /> },
          { path: '/subscrever', element: <SubscribePage /> },
          { path: '/equipas/nova', element: <NewTeamPage /> },
          { path: '/g/:guideId', element: <GuidePage /> },
          { path: '/convite/:token', element: <InvitePage /> },
          { path: '/extensao', element: <ExtensionPage /> },
          { path: '/mac', element: <MacAppPage /> },
          { path: '/mac/ligar', element: <MacLinkPage /> },
          { path: '/conta', element: <AccountPage /> },
          { path: '/admin', element: <AdminPage /> },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
